/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCampaignsCampaignIdAssignFilePost } from '../fn/campaigns/api-campaigns-campaign-id-assign-file-post';
import { ApiCampaignsCampaignIdAssignFilePost$Params } from '../fn/campaigns/api-campaigns-campaign-id-assign-file-post';
import { apiCampaignsCampaignIdDelete } from '../fn/campaigns/api-campaigns-campaign-id-delete';
import { ApiCampaignsCampaignIdDelete$Params } from '../fn/campaigns/api-campaigns-campaign-id-delete';
import { apiCampaignsCampaignIdGet } from '../fn/campaigns/api-campaigns-campaign-id-get';
import { ApiCampaignsCampaignIdGet$Params } from '../fn/campaigns/api-campaigns-campaign-id-get';
import { apiCampaignsCampaignIdItemsGet } from '../fn/campaigns/api-campaigns-campaign-id-items-get';
import { ApiCampaignsCampaignIdItemsGet$Params } from '../fn/campaigns/api-campaigns-campaign-id-items-get';
import { apiCampaignsCampaignIdItemsPost } from '../fn/campaigns/api-campaigns-campaign-id-items-post';
import { ApiCampaignsCampaignIdItemsPost$Params } from '../fn/campaigns/api-campaigns-campaign-id-items-post';
import { apiCampaignsCampaignIdMapColumnsPost } from '../fn/campaigns/api-campaigns-campaign-id-map-columns-post';
import { ApiCampaignsCampaignIdMapColumnsPost$Params } from '../fn/campaigns/api-campaigns-campaign-id-map-columns-post';
import { apiCampaignsCampaignIdPut } from '../fn/campaigns/api-campaigns-campaign-id-put';
import { ApiCampaignsCampaignIdPut$Params } from '../fn/campaigns/api-campaigns-campaign-id-put';
import { apiCampaignsCampaignIdStartPost } from '../fn/campaigns/api-campaigns-campaign-id-start-post';
import { ApiCampaignsCampaignIdStartPost$Params } from '../fn/campaigns/api-campaigns-campaign-id-start-post';
import { apiCampaignsCampaignIdStopPatch } from '../fn/campaigns/api-campaigns-campaign-id-stop-patch';
import { ApiCampaignsCampaignIdStopPatch$Params } from '../fn/campaigns/api-campaigns-campaign-id-stop-patch';
import { apiCampaignsGet } from '../fn/campaigns/api-campaigns-get';
import { ApiCampaignsGet$Params } from '../fn/campaigns/api-campaigns-get';
import { apiCampaignsItemsCampaignItemIdDelete } from '../fn/campaigns/api-campaigns-items-campaign-item-id-delete';
import { ApiCampaignsItemsCampaignItemIdDelete$Params } from '../fn/campaigns/api-campaigns-items-campaign-item-id-delete';
import { apiCampaignsItemsCampaignItemIdGet } from '../fn/campaigns/api-campaigns-items-campaign-item-id-get';
import { ApiCampaignsItemsCampaignItemIdGet$Params } from '../fn/campaigns/api-campaigns-items-campaign-item-id-get';
import { apiCampaignsItemsCampaignItemIdPut } from '../fn/campaigns/api-campaigns-items-campaign-item-id-put';
import { ApiCampaignsItemsCampaignItemIdPut$Params } from '../fn/campaigns/api-campaigns-items-campaign-item-id-put';
import { apiCampaignsPost } from '../fn/campaigns/api-campaigns-post';
import { ApiCampaignsPost$Params } from '../fn/campaigns/api-campaigns-post';
import { apiCampaignsRegistryPropertiesGet } from '../fn/campaigns/api-campaigns-registry-properties-get';
import { ApiCampaignsRegistryPropertiesGet$Params } from '../fn/campaigns/api-campaigns-registry-properties-get';
import { CampaignDto } from '../models/campaign-dto';
import { CampaignRegistryProperties } from '../models/campaign-registry-properties';
import { CreateCampaignItemResult } from '../models/create-campaign-item-result';
import { CreateCampaignResult } from '../models/create-campaign-result';
import { GetCampaignItemByIdResult } from '../models/get-campaign-item-by-id-result';
import { GetCampaignItemsResult } from '../models/get-campaign-items-result';
import { GetCampaignsResult } from '../models/get-campaigns-result';
import { MapCampaignColumnsResult } from '../models/map-campaign-columns-result';


/**
 * Outbound call campaigns — agent calls phone numbers from a registry
 */
@Injectable({ providedIn: 'root' })
export class CampaignsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCampaignsGet()` */
  static readonly ApiCampaignsGetPath = '/api/campaigns';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsGet$Response(params?: ApiCampaignsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignsResult>> {
    const obs = apiCampaignsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsGet(params?: ApiCampaignsGet$Params, context?: HttpContext): Observable<GetCampaignsResult> {
    const resp = this.apiCampaignsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCampaignsResult>): GetCampaignsResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsPost()` */
  static readonly ApiCampaignsPostPath = '/api/campaigns';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsPost$Response(params?: ApiCampaignsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCampaignResult>> {
    const obs = apiCampaignsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsPost(params?: ApiCampaignsPost$Params, context?: HttpContext): Observable<CreateCampaignResult> {
    const resp = this.apiCampaignsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateCampaignResult>): CreateCampaignResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdGet()` */
  static readonly ApiCampaignsCampaignIdGetPath = '/api/campaigns/{campaignId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdGet$Response(params: ApiCampaignsCampaignIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignDto>> {
    const obs = apiCampaignsCampaignIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdGet(params: ApiCampaignsCampaignIdGet$Params, context?: HttpContext): Observable<CampaignDto> {
    const resp = this.apiCampaignsCampaignIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CampaignDto>): CampaignDto => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdPut()` */
  static readonly ApiCampaignsCampaignIdPutPath = '/api/campaigns/{campaignId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdPut$Response(params: ApiCampaignsCampaignIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsCampaignIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdPut(params: ApiCampaignsCampaignIdPut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsCampaignIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdDelete()` */
  static readonly ApiCampaignsCampaignIdDeletePath = '/api/campaigns/{campaignId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdDelete$Response(params: ApiCampaignsCampaignIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsCampaignIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdDelete(params: ApiCampaignsCampaignIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsCampaignIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdAssignFilePost()` */
  static readonly ApiCampaignsCampaignIdAssignFilePostPath = '/api/campaigns/{campaignId}/assign-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdAssignFilePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdAssignFilePost$Response(params: ApiCampaignsCampaignIdAssignFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsCampaignIdAssignFilePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdAssignFilePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdAssignFilePost(params: ApiCampaignsCampaignIdAssignFilePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsCampaignIdAssignFilePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdMapColumnsPost()` */
  static readonly ApiCampaignsCampaignIdMapColumnsPostPath = '/api/campaigns/{campaignId}/map-columns';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdMapColumnsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdMapColumnsPost$Response(params: ApiCampaignsCampaignIdMapColumnsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MapCampaignColumnsResult>> {
    const obs = apiCampaignsCampaignIdMapColumnsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdMapColumnsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdMapColumnsPost(params: ApiCampaignsCampaignIdMapColumnsPost$Params, context?: HttpContext): Observable<MapCampaignColumnsResult> {
    const resp = this.apiCampaignsCampaignIdMapColumnsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MapCampaignColumnsResult>): MapCampaignColumnsResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdItemsGet()` */
  static readonly ApiCampaignsCampaignIdItemsGetPath = '/api/campaigns/{campaignId}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdItemsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdItemsGet$Response(params: ApiCampaignsCampaignIdItemsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignItemsResult>> {
    const obs = apiCampaignsCampaignIdItemsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdItemsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdItemsGet(params: ApiCampaignsCampaignIdItemsGet$Params, context?: HttpContext): Observable<GetCampaignItemsResult> {
    const resp = this.apiCampaignsCampaignIdItemsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCampaignItemsResult>): GetCampaignItemsResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdItemsPost()` */
  static readonly ApiCampaignsCampaignIdItemsPostPath = '/api/campaigns/{campaignId}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdItemsPost$Response(params: ApiCampaignsCampaignIdItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCampaignItemResult>> {
    const obs = apiCampaignsCampaignIdItemsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsCampaignIdItemsPost(params: ApiCampaignsCampaignIdItemsPost$Params, context?: HttpContext): Observable<CreateCampaignItemResult> {
    const resp = this.apiCampaignsCampaignIdItemsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateCampaignItemResult>): CreateCampaignItemResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsItemsCampaignItemIdGet()` */
  static readonly ApiCampaignsItemsCampaignItemIdGetPath = '/api/campaigns/items/{campaignItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsItemsCampaignItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsItemsCampaignItemIdGet$Response(params: ApiCampaignsItemsCampaignItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignItemByIdResult>> {
    const obs = apiCampaignsItemsCampaignItemIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsItemsCampaignItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsItemsCampaignItemIdGet(params: ApiCampaignsItemsCampaignItemIdGet$Params, context?: HttpContext): Observable<GetCampaignItemByIdResult> {
    const resp = this.apiCampaignsItemsCampaignItemIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCampaignItemByIdResult>): GetCampaignItemByIdResult => r.body)
    );
  }

  /** Path part for operation `apiCampaignsItemsCampaignItemIdPut()` */
  static readonly ApiCampaignsItemsCampaignItemIdPutPath = '/api/campaigns/items/{campaignItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsItemsCampaignItemIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsItemsCampaignItemIdPut$Response(params: ApiCampaignsItemsCampaignItemIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsItemsCampaignItemIdPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsItemsCampaignItemIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCampaignsItemsCampaignItemIdPut(params: ApiCampaignsItemsCampaignItemIdPut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsItemsCampaignItemIdPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsItemsCampaignItemIdDelete()` */
  static readonly ApiCampaignsItemsCampaignItemIdDeletePath = '/api/campaigns/items/{campaignItemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsItemsCampaignItemIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsItemsCampaignItemIdDelete$Response(params: ApiCampaignsItemsCampaignItemIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsItemsCampaignItemIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsItemsCampaignItemIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsItemsCampaignItemIdDelete(params: ApiCampaignsItemsCampaignItemIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsItemsCampaignItemIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdStartPost()` */
  static readonly ApiCampaignsCampaignIdStartPostPath = '/api/campaigns/{campaignId}/start';

  /**
   * Starts a campaign, resumes a stopped one, or runs a finished one again.
   * Which of the three happens follows from the campaign's own status, so the
   * caller has nothing to pass: a stopped campaign continues where it left
   * off, a finished one has its registry reset first, and one that is already
   * running is left alone — the dialling chain picks up the next number by
   * itself once the current call ends.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdStartPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdStartPost$Response(params: ApiCampaignsCampaignIdStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsCampaignIdStartPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Starts a campaign, resumes a stopped one, or runs a finished one again.
   * Which of the three happens follows from the campaign's own status, so the
   * caller has nothing to pass: a stopped campaign continues where it left
   * off, a finished one has its registry reset first, and one that is already
   * running is left alone — the dialling chain picks up the next number by
   * itself once the current call ends.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdStartPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdStartPost(params: ApiCampaignsCampaignIdStartPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsCampaignIdStartPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsCampaignIdStopPatch()` */
  static readonly ApiCampaignsCampaignIdStopPatchPath = '/api/campaigns/{campaignId}/stop';

  /**
   * Stops a running campaign. A call already in progress is left to finish;
   * no further numbers are dialled.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsCampaignIdStopPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdStopPatch$Response(params: ApiCampaignsCampaignIdStopPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiCampaignsCampaignIdStopPatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Stops a running campaign. A call already in progress is left to finish;
   * no further numbers are dialled.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsCampaignIdStopPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsCampaignIdStopPatch(params: ApiCampaignsCampaignIdStopPatch$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiCampaignsCampaignIdStopPatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiCampaignsRegistryPropertiesGet()` */
  static readonly ApiCampaignsRegistryPropertiesGetPath = '/api/campaigns/registry-properties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCampaignsRegistryPropertiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsRegistryPropertiesGet$Response(params?: ApiCampaignsRegistryPropertiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignRegistryProperties>> {
    const obs = apiCampaignsRegistryPropertiesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCampaignsRegistryPropertiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCampaignsRegistryPropertiesGet(params?: ApiCampaignsRegistryPropertiesGet$Params, context?: HttpContext): Observable<CampaignRegistryProperties> {
    const resp = this.apiCampaignsRegistryPropertiesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CampaignRegistryProperties>): CampaignRegistryProperties => r.body)
    );
  }

}
